export {
  isSafari10,
  isSafariBefore10,
  isSafariBefore12,
  isSafariBefore8,
  uaIsChromeiOS,
  uaIsEdgeChakra,
  uaIsIE,
  uaIsIE10,
  uaIsIE11,
  uaIsIE9,
  uaIsSafari,
  uaIsSnap,
} from './recording';

type UaWindow = Window & { opr?: string };

function isChrome(): boolean {
  // copied from https://stackoverflow.com/a/13348618/58737
  // please note,
  // that IE11 now returns undefined again for window.chrome
  // and new Opera 30 outputs true for window.chrome
  // but needs to check if window.opr is not undefined
  // and new IE Edge outputs to true now for window.chrome
  // and if not iOS Chrome check
  // so use the below updated condition
  const winNav = window.navigator;
  const vendorName = winNav.vendor;
  const isOpera = typeof (window as UaWindow).opr !== 'undefined';
  // note "Edge" is used to identify Chromium engine while "Edg" identifies Chakra
  const isEdgeOrIE = winNav.userAgent.indexOf('Edge') > -1;
  const isIOSChrome = winNav.userAgent.match('CriOS');

  if (isIOSChrome) {
    // is Google Chrome on IOS
    return true;
  } else if (vendorName === 'Google Inc.' && !isOpera && !isEdgeOrIE) {
    // is Google Chrome
    return true;
  } else {
    // not Google Chrome
    return false;
  }
}

export const uaIsChrome = isChrome();

function isFirefox(): boolean {
  // Based on https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
  // (We don't care about the distinction between Firefox and Seamonkey here;
  // they're both Gecko.)
  return /Firefox/.test(window.navigator.userAgent);
}

export const uaIsFirefox = isFirefox();

function getFirefoxVersion(): number {
  const match = window.navigator.userAgent.match(/Firefox\/(\d+)/);
  return match && match[1] ? parseInt(match[1], 10) : -1;
}

export function isFirefoxBeforeVersionX(x: number): boolean {
  if (!uaIsFirefox) {
    return false;
  }
  return getFirefoxVersion() < x;
}

export function isFirefoxAfter(x: number): boolean {
  if (!uaIsFirefox) {
    return false;
  }
  return getFirefoxVersion() > x;
}

function getChromeVersion(): number {
  const match = window.navigator.userAgent.match(/Chrome\/(\d+)/);
  return match && match[1] ? parseInt(match[1], 10) : -1;
}

function isChromeAfter(x: number): boolean {
  if (!uaIsChrome) {
    return false;
  }
  return getChromeVersion() > x;
}

function isChromeBeforeVersionX(x: number): boolean {
  if (!uaIsChrome) {
    return false;
  }
  const chromeVersion = getChromeVersion();
  if (chromeVersion === -1) {
    return false;
  }
  return chromeVersion < x;
}

export const isChromeAfter129 = isChromeAfter(129);
export const isFirefoxAfter131 = isFirefoxAfter(131);
export const isFirefoxBefore28 = isFirefoxBeforeVersionX(28);
export const isFirefoxBefore27 = isFirefoxBeforeVersionX(27);
export const isChromeBefore23 = isChromeBeforeVersionX(23);
export const isChromeBefore38 = isChromeBeforeVersionX(38);
export const isChromeBefore57 = isChromeBeforeVersionX(57);
export const isChromeBefore60 = isChromeBeforeVersionX(60);
